import { CommonModule } from '@angular/common'
import { Component, EventEmitter, Input, Output } from '@angular/core'
import { MatIconModule } from '@angular/material/icon'

/**
 * Represents a single tag in a tag array
 */
@Component({
  selector: 'ngx-micetribe-tag',
  templateUrl: './tag.component.html',
  styleUrls: ['./tag.component.scss'],
  standalone: true,
  imports: [CommonModule, MatIconModule]
})
export class TagComponent {
  /**
   * Tag title
   */
  @Input()
  title = ''

  /**
   * Sets the tag as clickable
   */
  @Input()
  isClickable: boolean

  /**
   * Emits when the tag is clicked
   */
  @Output()
  clicked = new EventEmitter<never>()

  /**
   * Handles tag click
   */
  isClicked() {
    this.clicked.emit()
  }
}
